import { motion, useReducedMotion } from 'motion/react';
import { EASE_PREMIUM, MOTION } from '@/lib/motion';
import { cn } from '@/lib/utils';

export function RadarPing({ className }: { className?: string }) {
  const reduced = useReducedMotion();
  if (reduced) return null;
  return (
    <motion.span
      aria-hidden
      className={cn('absolute inset-0 rounded-full', className)}
      initial={{ scale: 1, opacity: 0.35 }}
      animate={{ scale: 1.75, opacity: 0 }}
      transition={{
        duration: MOTION.pulse,
        ease: EASE_PREMIUM,
        repeat: Infinity,
        repeatDelay: MOTION.pulseGap,
      }}
    />
  );
}
